// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let LevelLine = function (name, level, color, width, style)
{
    this.LineNumber = -1;
    this.Name = name;
    this.color = color;
    this.width = width;
    this.style = style;
    this.level = level;
    this.Vector = null;
}

Object.defineProperty(LevelLine.prototype, "Level",
    {
        get: function () { return this.level; },
        set: function (value)
        {
            this.level = value;
            if (this.Vector !== null)
                this.Vector.Value = this.level;
        }
    });
